// ProfileNavigation helper functions and data
import React from "react";

import { ProfileNavigationTab } from "./ProfileNavigation.types";

import ClientProfileSVG from "../../../../public/assets/images/anefi/book.svg";
import GlosarySVG from "../../../../public/assets/images/anefi/glosary.svg";
import LegalsSVG from "../../../../public/assets/images/anefi/open-book.svg";
import EditSVG from "../../../../public/assets/images/anefi/pencil.svg";
import SupportSVG from "../../../../public/assets/images/anefi/support.svg";
import MovementsSVG from "../../../../public/assets/images/anefi/union.svg";
import NotificationSVG from "../../../../public/assets/images/alarm.svg";

export const tabs: (ProfileNavigationTab | null)[] = [
  {
    icon: <GlosarySVG />,
    tabName: "Glosario de términos",
    isExternal: false,
    url: "/profile/glossary",
    authenticated: false,
    category: "Anefi"
  },
  {
    icon: <MovementsSVG />,
    tabName: "Movimientos",
    isExternal: false,
    url: "/profile/movements",
    authenticated: true,
    category: "Cuenta"
  },
  {
    icon: <NotificationSVG />,
    tabName: "Notificaciones",
    isExternal: false,
    url: "/profile/notifications",
    authenticated: true,
    category: "Cuenta"
  },
  {
    icon: <EditSVG />,
    tabName: "Editar cuenta",
    isExternal: false,
    url: "/profile/edit-profile",
    authenticated: true
  },
  {
    icon: <ClientProfileSVG />,
    tabName: "Perfil de cliente",
    isExternal: false,
    url: "/profile/user",
    authenticated: true
  },
  {
    icon: <LegalsSVG />,
    tabName: "Legales",
    isExternal: false,
    url: "/profile/legal",
    authenticated: false
  },
  {
    icon: <SupportSVG />,
    tabName: "Soporte",
    isExternal: false,
    url: "/profile/support",
    authenticated: false
  }
];
